import { organizationInfo } from "@/mocks/home";
import Logo from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <Logo variant="light" />
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              Pertubuhan kebajikan berdaftar yang berkhidmat untuk membangunkan
              insan dan membantu komuniti yang memerlukan di seluruh Malaysia.
            </p>
            <p className="mt-4 text-xs text-background-50/50">
              No. Pendaftaran: {organizationInfo.registrationNo}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              Pautan Pantas
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#tentang" className="text-background-50/70 hover:text-accent-400 transition-colors cursor-pointer">Tentang Kami</a></li>
              <li><a href="#program" className="text-background-50/70 hover:text-accent-400 transition-colors cursor-pointer">Program</a></li>
              <li><a href="#sumbangan" className="text-background-50/70 hover:text-accent-400 transition-colors cursor-pointer">Cara Menyumbang</a></li>
              <li><a href="#sukarelawan" className="text-background-50/70 hover:text-accent-400 transition-colors cursor-pointer">Sukarelawan</a></li>
              <li><a href="#hubungi" className="text-background-50/70 hover:text-accent-400 transition-colors cursor-pointer">Hubungi Kami</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              Hubungi Kami
            </h4>
            <ul className="space-y-3 text-sm text-background-50/70">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>{organizationInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-accent-400"></i>
                <span>{organizationInfo.phone}</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-accent-400"></i>
                <span>{organizationInfo.email}</span>
              </li>
            </ul>
          </div>

          {/* Registered */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              Pertubuhan Berdaftar
            </h4>
            <p className="text-sm text-background-50/70 leading-relaxed">
              Berdaftar di bawah {organizationInfo.act} dengan nombor pendaftaran{" "}
              <span className="text-accent-400 font-medium">
                {organizationInfo.registrationNo}
              </span>
              .
            </p>
            <div className="mt-4 flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10">
                <i className="ri-facebook-fill"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10">
                <i className="ri-instagram-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10">
                <i className="ri-youtube-line"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            © {year} {organizationInfo.name}. Hak cipta terpelihara.
          </p>
          <p className="text-xs text-background-50/50">
            {organizationInfo.domain}
          </p>
        </div>
      </div>
    </footer>
  );
}